/**
 * Convert an ISO datetime string into the value shape an HTML
 * `<input type="datetime-local">` accepts, i.e. `YYYY-MM-DDTHH:mm`
 * in the browser's local timezone. Returns an empty string for null,
 * undefined, empty, or unparseable input — convenient for binding to
 * RHF's `defaultValues`/`reset` where `null` would render `null` in
 * the input.
 *
 * Pair with `new Date(value).toISOString()` on submit to roundtrip
 * back to the API's tz-stable storage.
 */
export function toLocalDateTime(iso?: string | null): string {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    const off = d.getTimezoneOffset();
    return new Date(d.getTime() - off * 60_000).toISOString().slice(0, 16);
}
